import { SERVER_URL } from './apiConstants';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { toast } from 'react-toastify';

const headers = {
  'Content-Type': 'application/json; charset=utf-8',
  'Access-Control-Allow-Origin': '*',
};
const signup = 'signup';
export const signUp = createAsyncThunk('api/signup', async (data) => {
  const body = {
    name: data.name,
    email: data.email,
    phone: data.phone,
    password: data.password,
    businessName: data.businessName,
    userType: data.userType,
  };
  return axios
    .post(`${SERVER_URL}/${signup}`, body, { headers })
    .then((response) => response.data)
    .catch((e) => e);
});

const registrationSlice = createSlice({
  name: 'api',
  initialState: {
    loading: false,
    signupData: {},
    error: '',
  },
  extraReducers: {
    [signUp.pending]: (state) => {
      state.loading = true;
    },
    [signUp.fulfilled]: (state, action) => {
      state.loading = false;
      state.signupData = action.payload;
      if (action.payload && action.payload.data) {
        toast.success(
          'An OTP has been sent to your email address. Please check your inbox and enter the OTP to verify your account.'
        );
      }
    },
    [signUp.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      toast.error('Error');
    },
  },
});

export default registrationSlice.reducer;
